import { updateIfpApplication } from '@sec-loans-ui/ifp-loans/api/endpoints'
import { getWizardData, wizardDataToApplicationData } from '@sec-loans-ui/ifp-loans/utils'
import { IfpWizardData } from '@sec-loans-ui/ifp-loans/wizard/types'
import { WizardContext } from '@sec-loans-ui/ifp-loans/wizard/wizardMachine'
import { assertValue } from '@shared/helpers'
import { IfpLoan } from '@shared/sec-loans'
import { FormStepActions, FormStepState, useFormStepState as useCommonFormStepState } from '@ui-common/state'
import { fromPromise } from 'xstate'

type FormStateContext = Pick<WizardContext, 'applicationId'>

export const useFormStepState = (
  applicationId: string,
  loan: IfpLoan,
  parentActions: FormStepActions<Partial<IfpWizardData>>,
): FormStepState<FormStateContext, Partial<IfpWizardData>> =>
  useCommonFormStepState<FormStateContext, Partial<IfpWizardData>>({ applicationId }, parentActions, {
    actors: {
      save: fromPromise<Partial<IfpWizardData>, { data: Partial<IfpWizardData>; context: FormStateContext }>(
        async ({ input }) => {
          const wizardData = getWizardData(input.data, loan)
          await updateIfpApplication(
            {
              data: wizardDataToApplicationData(wizardData, loan),
            },
            assertValue(input.context.applicationId, 'input.context.applicationId'),
          )
          return input.data
        },
      ),
    },
  })
